import { CxIntegrationLicence } from '../../../NonReact/common/Types/SelfProvisioning/SelfProvisioningTypes'
import { DEFAULT_TIMEZONE } from '../../TimezoneModal/Constants/Constants'
import { ApplicationUserFormData, InitialApplicationUserValues } from '../Types'
import { IsVarEmpty } from '../../../NonReact/utils/GlobalFunctions'

/**
 * Merges optional add-user prefills into the default form state without dropping required nested defaults.
 *
 * @param defaultValues - Baseline form values used for a new user.
 * @param initialValues - Optional nested overrides supplied by the caller.
 * @returns Form state with nested defaults preserved where no override was provided.
 */
export const mergeInitialUserFormValues = (
    defaultValues: ApplicationUserFormData,
    initialValues?: InitialApplicationUserValues
): ApplicationUserFormData => {
    const role: ApplicationUserFormData['role'] =
        IsVarEmpty(defaultValues.role) && IsVarEmpty(initialValues?.role)
            ? undefined
            : {
                  ...(defaultValues.role ?? {}),
                  ...(initialValues?.role ?? {})
              }

    const administrator: ApplicationUserFormData['administrator'] =
        IsVarEmpty(defaultValues.administrator) && IsVarEmpty(initialValues?.administrator)
            ? undefined
            : {
                  ...(defaultValues.administrator ?? {}),
                  ...(initialValues?.administrator ?? {})
              }

    const details: ApplicationUserFormData['details'] =
        IsVarEmpty(defaultValues.details) && IsVarEmpty(initialValues?.details)
            ? undefined
            : {
                  ...(defaultValues.details ?? {}),
                  ...(initialValues?.details ?? {}),
                  cxilicence:
                      initialValues?.details?.cxilicence ??
                      defaultValues.details?.cxilicence ??
                      CxIntegrationLicence.NONE,
                  cxidataentitlement:
                      initialValues?.details?.cxidataentitlement ?? defaultValues.details?.cxidataentitlement ?? false,
                  timezone: initialValues?.details?.timezone ?? defaultValues.details?.timezone ?? DEFAULT_TIMEZONE
              }

    const settings: ApplicationUserFormData['settings'] =
        IsVarEmpty(defaultValues.settings) && IsVarEmpty(initialValues?.settings)
            ? undefined
            : {
                  ...(defaultValues.settings ?? {}),
                  ...(initialValues?.settings ?? {})
              }

    const permissions: ApplicationUserFormData['permissions'] =
        IsVarEmpty(defaultValues.permissions) && IsVarEmpty(initialValues?.permissions)
            ? undefined
            : {
                  ...(defaultValues.permissions ?? {}),
                  ...(initialValues?.permissions ?? {})
              }

    const extensionendpoint: ApplicationUserFormData['extensionendpoint'] =
        IsVarEmpty(defaultValues.extensionendpoint) && IsVarEmpty(initialValues?.extensionendpoint)
            ? undefined
            : {
                  ...(defaultValues.extensionendpoint ?? {}),
                  ...(initialValues?.extensionendpoint ?? {})
              }

    const reporting: ApplicationUserFormData['reporting'] =
        IsVarEmpty(defaultValues.reporting) && IsVarEmpty(initialValues?.reporting)
            ? undefined
            : {
                  ...(defaultValues.reporting ?? {}),
                  ...(initialValues?.reporting ?? {})
              }

    const apiKeys: ApplicationUserFormData['apiKeys'] =
        IsVarEmpty(defaultValues.apiKeys) && IsVarEmpty(initialValues?.apiKeys)
            ? undefined
            : {
                  ...(defaultValues.apiKeys ?? {}),
                  ...(initialValues?.apiKeys ?? {})
              }

    return {
        ...defaultValues,
        role,
        administrator,
        details,
        settings,
        permissions,
        extensionendpoint,
        reporting,
        apiKeys
    }
}
